export const BT21 = 'bt21';
export const BNF = 'bnf';
export const BRAWLSTARS = 'brawlstars';
export const WDZY = 'wdzy';
export const GRAFFLEX = 'grafflex';
export const TRUZ = 'truz';
export const LINETYPES = [BNF, BT21, BRAWLSTARS, TRUZ];
